module.exports = function cleanDescription(strg) {
  var newText = strg.replace(/([*])\W/g, "");
  return newText;
};
